export type AdhocEmailRow = Record<string, unknown> & {
  id: number;
  employeeId?: number | string | null;
  firstName?: string | null;
  lastName?: string | null;
  itFirstName?: string | null;
  itLastName?: string | null;
  employeeName?: string | null;
  purposedEmail?: string | null;
  proposedEmail?: string | null;
  personalEmail?: string | null;
  contactNumber?: string | null;
  phoneNumber?: string | null;
  contactNo?: string | null;
  requestByName?: string | null;
  requestDateTime?: string | null;
  createdByName?: string | null;
  createdDateTime?: string | null;
  createdAt?: string | null;
  createdBy?: string | number | null;
  ccEmail?: string | null;
  comment?: string | null;
  hrComment?: string | null;
  status?: string | null;
  requestType?: string | null;
  empType?: string | null;
  employeeType?: string | null;
  companyName?: string | null;
  agencyName?: string | null;
  agencyContactNumber?: string | null;
  pocName?: string | null;
};

export type AdhocListResult = {
  rows: AdhocEmailRow[];
  total: number;
};

export function parseAdhocList(payload: unknown): AdhocListResult {
  const record = payload && typeof payload === "object"
    ? payload as Record<string, unknown>
    : {};
  const nested = record.data && typeof record.data === "object" && !Array.isArray(record.data)
    ? record.data as Record<string, unknown>
    : null;
  const rawRows = Array.isArray(record.data)
    ? record.data
    : Array.isArray(nested?.content)
      ? nested.content
      : Array.isArray(nested?.data)
        ? nested.data
        : [];
  const rows = rawRows.filter(
    (row): row is AdhocEmailRow => row != null && typeof row === "object",
  );
  const rawTotal = record.totalRequest ?? nested?.totalElements ?? nested?.totalRequest;
  const total = Number(rawTotal);
  return { rows, total: Number.isFinite(total) ? total : rows.length };
}

export function rowEmployeeName(row: AdhocEmailRow): string {
  const name = [row.firstName, row.lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  return name || row.employeeName?.trim() || "-";
}

export function proposedEmail(row: AdhocEmailRow): string {
  return String(row.proposedEmail ?? row.purposedEmail ?? "-");
}

export function employeeTypeLabel(employeeType?: string | null): string {
  const value = String(employeeType ?? "").trim();
  if (!value) return "-";
  if (value.toUpperCase() === "REGULAR") return "Regular";
  return value
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function companyNameLabel(companyName?: string | null): string {
  const value = String(companyName ?? "").trim();
  const labels: Record<string, string> = {
    CCI_INDIA: "Caelius Consulting India",
    CCI_US: "Caelius Consulting US",
  };
  return labels[value.toUpperCase()] ?? value;
}

export function isTimesheetAccessRequest(row: AdhocEmailRow): boolean {
  const value = String(row.requestType ?? "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  return value.includes("TIMESHEET") || value.includes("C1ACCESS");
}
